/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useAuth} from '../../../../../app/modules/auth'
import {app_id, ENV_CLIENT} from '../../../../../app/modules/config'
import {useUserStateProvider} from '../../../../../app/utils/contextProvider/UserStateProvider'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const {currentUser} = useAuth()
  const {roleDetailMenus, loadingMenu} = useUserStateProvider()

  return (
    <>
      {/* Analyze menu */}
      {(app_id === 0 || app_id === 2 || app_id === 3) && (
        <SidebarMenuItemWithSub to='/analyze' title='Analyze' icon='chart-simple'>
          <SidebarMenuItem to={'/analyze/dashboard'} title='Dashboard' hasBullet={true} />
          <SidebarMenuItem to='/analyze/logs' title='Logs' hasBullet={true} />
          {app_id === 3 ||
            (app_id === 0 && (
              <>
                <SidebarMenuItem to='/analyze/queue' title='Queue' hasBullet={true} />
                {/* <SidebarMenuItem to='/analyze/reports' title='Reports' hasBullet={true} /> */}
              </>
            ))}
          <SidebarMenuItem to='/analyze/export' title='Export' hasBullet={true} />
          <SidebarMenuItem to='/analyze/reports' title='Reports' hasBullet={true} />
        </SidebarMenuItemWithSub>
      )}
      {/* People Menu */}
      {/* <SidebarMenuItemWithSub to='/people' title='People' icon='people'>
        <SidebarMenuItem to='/people/persons' title='Persons' hasBullet={true} />
        <SidebarMenuItem to='/people/companies' title='Companies' hasBullet={true} />
        <SidebarMenuItem to='/people/segments' title='Segments' hasBullet={true} />
        <SidebarMenuItem to='/people/tags' title='Tags' hasBullet={true} />
        <SidebarMenuItem to='/people/configuration' title='Configuration' hasBullet={true} />
      </SidebarMenuItemWithSub> */}
      {/* Dashboard For SMS Aggregator */}
      {app_id === 0 && (
        <SidebarMenuItem
          to='/dashboard'
          icon='element-11'
          title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          fontIcon='bi-app-indicator'
        />
      )}

      {/* Sender */}
      <SidebarMenuItem to='/smsbroadcast/senderid' title='Sender ID' icon='send' />
      {/* Inbox */}
      {/* <SidebarMenuItem to='/inbox/chat' title='Inbox' icon='message-programming' /> */}
      {/* Route Management For Route Application */}
      {(app_id === 0 || app_id === 3) && (
        <SidebarMenuItemWithSub to='/routes' title='Route' icon='map'>
          <SidebarMenuItem to='/routes' title='Routes' hasBullet={true} />
          <SidebarMenuItem to='/route-management' title='Route Management' hasBullet={true} />
        </SidebarMenuItemWithSub>
      )}
      {/* SMS Broadcast For Aggregator */}
      {app_id === 0 && (
        <SidebarMenuItemWithSub
          to='/crafted/smsbroadcast'
          title='SMS Broadcast'
          icon='sms'
          fontIcon='bi-person'
        >
          <SidebarMenuItem to='/smsbroadcast/quicksms' title='Quick SMS' hasBullet={true} />
          <SidebarMenuItem to='/smsbroadcast/groupsms' title='Group SMS' hasBullet={true} />
          <SidebarMenuItem
            to='/smsbroadcast/contactfilesms'
            title='Contact File SMS'
            hasBullet={true}
          />
          <SidebarMenuItem to='/smsbroadcast/senderid' title='Sender ID' hasBullet={true} />
          <SidebarMenuItem to='/smsbroadcast/smscampaign' title='SMS Campaign' hasBullet={true} />
          <SidebarMenuItem to='/smsbroadcast/smartsms' title='Smart SMS' hasBullet={true} />
          <SidebarMenuItem to='/smsbroadcast/smstemplete' title='SMS Templete' hasBullet={true} />
        </SidebarMenuItemWithSub>
      )}
      {/* DLR Management */}
      {app_id === 0 ||
        (app_id === 3 && (
          <SidebarMenuItem to='/dlr-management' title='DLR Management' icon='abstract-7' />
        ))}
      {/* Contact */}
      {app_id === 0 && (
        <SidebarMenuItemWithSub to='/contacts' title='Contacts' fontIcon='people' icon='people'>
          <SidebarMenuItem to='/contacts/contact-group' title='Contact Group' hasBullet={true} />
          <SidebarMenuItem to='/contacts/contact-list' title='Contact List' hasBullet={true} />
        </SidebarMenuItemWithSub>
      )}
      {/* Users Management */}
      {currentUser?.user_profile !== 3 && (
        <>
          {(app_id === 0 || app_id === 2 || app_id === 3) && (
            <SidebarMenuItemWithSub
              to='/users'
              title='Users'
              fontIcon='bi-person'
              icon='profile-circle'
            >
              <SidebarMenuItem to='/users/list' title='User List' hasBullet={true} />
              <SidebarMenuItem to='/users/create-user' title='Create User' hasBullet={true} />
              {app_id !== 3 && <SidebarMenuItem to='/users/role' title='Role' hasBullet={true} />}
              {app_id === 0 && (
                <SidebarMenuItem to='/users/smsc-assign' title='SMSC Assign' hasBullet={true} />
              )}
              {/* <SidebarMenuItem to='/users/cloneuser' title='Clone User' hasBullet={true} /> */}
              {app_id === 0 && (
                <>
                  {/* <SidebarMenuItem
                    to='/users/roles-management'
                    title='Role Management'
                    hasBullet={true}
                  /> */}
                </>
              )}
            </SidebarMenuItemWithSub>
          )}
        </>
      )}
      {/* Menu Management TOP ADMIN ONLY/IT'S US */}
      {app_id === 0 && (
        <SidebarMenuItemWithSub
          to='/menu-management'
          title='Menu Management'
          fontIcon='bi-person'
          icon='folder'
        >
          <SidebarMenuItem to='/menu-management/link' title='Link' hasBullet={true} />
          <SidebarMenuItem to='/menu-management/menu' title='Menu' hasBullet={true} />
          <SidebarMenuItem to='/menu-management/submenu' title='Sub Menu' hasBullet={true} />
        </SidebarMenuItemWithSub>
      )}
      {app_id === 0 || app_id === 2 ? (
        <>
          {/* Spam Filter */}
          <SidebarMenuItem to='/spam-filter' title='Spam Filter' icon='flask' />

          {/* Payment Request */}
          {/* <SidebarMenuItem to='/paymentrequest' title='Payment Request' icon='bill' /> */}

          {/* Payment */}
          <SidebarMenuItemWithSub to='/payment' title='Payment' icon='bill'>
            <SidebarMenuItem to='/payment/request' title='Request Payment' hasBullet={true} />
            <SidebarMenuItem to='/payment/add-payment' title='Add Payment' hasBullet={true} />
            <SidebarMenuItem
              to='/payment/balance-history'
              title='Balance History'
              hasBullet={true}
            />
          </SidebarMenuItemWithSub>

          {/* Price List */}
          <SidebarMenuItemWithSub
            to='/pricelist'
            title='Price List'
            fontIcon='bi bi-list-task'
            icon='bi bi-list-columns-reverse'
          >
            <SidebarMenuItem to='/pricelist/price' title='Price' hasBullet={true} />
          </SidebarMenuItemWithSub>

          {/* Billing */}
          <SidebarMenuItemWithSub
            to='/billing/transactionreports'
            title='Billing'
            fontIcon='bi bi-reception-4'
            icon='bi bi-reception-4'
          >
            {/* <SidebarMenuItem
              to='/billing/transactionreports/rechargefrom'
              title='Recharge From'
              hasBullet={true}
            /> */}
            <SidebarMenuItem
              to='/billing/transactionreports/rechargeto'
              title='Recharge To'
              hasBullet={true}
            />
            <SidebarMenuItem to='/billing/invoice/create' title='Invoice Create' hasBullet={true} />
            <SidebarMenuItem to='/billing/invoice/list' title='Invoice List' hasBullet={true} />
            <SidebarMenuItem to='/billing/voucher' title='Voucher' hasBullet={true} />
            <SidebarMenuItem to='/customer-ledger' title='Customer Ledger' hasBullet={true} />
          </SidebarMenuItemWithSub>

          {/* Push Management */}
          <SidebarMenuItemWithSub
            to='/push-management'
            title='Push Management'
            icon='message-notif'
          >
            <SidebarMenuItem to='/push-management/inbox-push' title='Inbox Push' hasBullet={true} />
            {ENV_CLIENT !== 'link3' && (
              <SidebarMenuItem to='/push-management/dlr-push' title='DLR Push' hasBullet={true} />
            )}
            <SidebarMenuItem
              to='/push-management/documentation'
              title='API Documentation'
              hasBullet={true}
            />
          </SidebarMenuItemWithSub>

          {/* Middleware */}
          <SidebarMenuItemWithSub to='/middleware-management' title='Middleware' icon='map'>
            {/* <SidebarMenuItem to='/middleware/smsc-assign' title='SMSC Assign' hasBullet={true} /> */}
            <SidebarMenuItem
              to='/middleware-management/user'
              title='User Management'
              hasBullet={true}
            />
            <SidebarMenuItem
              to='/middleware-management/sender'
              title='Sender Management'
              hasBullet={true}
            />
          </SidebarMenuItemWithSub>

          <SidebarMenuItemWithSub to='/log' title='Log' fontIcon='bi bi-telephone' icon='setting-4'>
            <SidebarMenuItem to='/log/activity-log' title='Activity Log' hasBullet={true} />
            <SidebarMenuItem to='/log/access-log' title='Access Log' hasBullet={true} />
          </SidebarMenuItemWithSub>

          {/* Customer Ledger */}
          {/* <SidebarMenuItem to='/customer-ledger' title='Customer Ledger' icon='cheque' /> */}

          {/* Developer Options */}
          {app_id === 0 && (
            <SidebarMenuItemWithSub
              to='/developeroptions'
              title='Developer Options'
              fontIcon='bi bi-person-workspace'
              icon='bi bi-person-workspace'
            >
              <SidebarMenuItem
                to='/developeroptions/changepassword'
                title='Change Password'
                hasBullet={true}
              />
              <SidebarMenuItem to='/developeroptions/apikey' title='API Key' hasBullet={true} />
              <SidebarMenuItem
                to='/developeroptions/documentation'
                title='Documentation'
                hasBullet={true}
              />
            </SidebarMenuItemWithSub>
          )}
        </>
      ) : null}
      {app_id === 0 && (
        <>
          {/* {currentUser?.user_profile === 3 || currentUser?.user_profile === 2 ? null : (
  <SidebarMenuItem to='/smsfiltertext' title='SMS Filter Text' hasBullet={true} />
)} */}

          <SidebarMenuItemWithSub
            to='/livereports'
            title='Live Reports'
            fontIcon='bi bi-broadcast-pin'
            icon='bi bi-broadcast-pin'
          >
            <SidebarMenuItem
              to='/livereports/todaybroadcast'
              title='Today Broadcast'
              hasBullet={true}
            />
            <SidebarMenuItem to='/livereports/todaysms' title='Today SMS' hasBullet={true} />
            {/* <SidebarMenuItem to='/livereports/smstodayapi' title='SMS Today-API ' hasBullet={true} /> */}
            {/* <SidebarMenuItem to='/livereports/smstodayapireportdownload' title='SMS TodayAPI ReportDownload ' hasBullet={true} /> */}
            <SidebarMenuItem to='/livereports/summerylogs' title='Summery Logs ' hasBullet={true} />
            <SidebarMenuItem
              to='/livereports/retrysmslist'
              title='Retry SMS List '
              hasBullet={true}
            />
          </SidebarMenuItemWithSub>

          {/* {currentUser?.user_profile === 3 || currentUser?.user_profile === 2 ? null : (
  <SidebarMenuItemWithSub
    to='/monitoring'
    title='Monitoring'
    fontIcon='bi bi-diagram-3'
    icon='bi bi-diagram-3'
  >
    <SidebarMenuItem
      to='/monitoring/mnobalancenotifyList'
      title='MNOBalanceNotifyList'
      hasBullet={true}
    />
    <SidebarMenuItem
      to='/monitoring/balancenotificationlog'
      title='BalanceNotificationLog'
      hasBullet={true}
    />
    <SidebarMenuItem
      to='/monitoring/balancethreshold'
      title='Balance Threshold'
      hasBullet={true}
    />
  </SidebarMenuItemWithSub>
)} */}

          <SidebarMenuItemWithSub
            to='/settings'
            title='Settings'
            fontIcon='bi bi-gear-wide-connected'
            icon='bi bi-gear-wide-connected'
          >
            <SidebarMenuItem to='/settings/logoupdates' title='Logo Updates' hasBullet={true} />
          </SidebarMenuItemWithSub>

          <SidebarMenuItemWithSub
            to='/archive'
            title='Archive'
            fontIcon='bi bi-file-earmark-spreadsheet'
            icon='bi bi-file-earmark-spreadsheet'
          >
            <SidebarMenuItem
              to='/archive/broadcasthistory'
              title='Broadcast History'
              hasBullet={true}
            />
            <SidebarMenuItem to='/archive/smshistory' title='SMS History' hasBullet={true} />
            {/* <SidebarMenuItem to='/archive/smshistoryapi' title='SMS History-API' hasBullet={true} /> */}
            {/* <SidebarMenuItem to='/livereports/summerylogs' title='Summery Logs ' hasBullet={true} /> */}
            <SidebarMenuItem
              to='/archive/archivedeliverylogreport'
              title='Delivery Log Report '
              hasBullet={true}
            />
            {/* <SidebarMenuItem to='/archive/apireportdownload' title='API Report Download ' hasBullet={true} /> */}
            {/* <SidebarMenuItem to='/archive/panelreportdownload' title='Panel Report Download ' hasBullet={true} /> */}
          </SidebarMenuItemWithSub>

          {currentUser?.user_profile === 1 ||
          currentUser?.user_profile === 2 ||
          currentUser?.user_profile === 3 ? (
            <SidebarMenuItemWithSub
              to='/billing/transactionreports'
              title='Billing'
              fontIcon='bi bi-reception-4'
              icon='bi bi-reception-4'
            >
              <SidebarMenuItem
                to='/billing/transactionreports/rechargefrom'
                title='Recharge From'
                hasBullet={true}
              />

              {currentUser?.user_profile === 1 || currentUser?.user_profile === 2 ? (
                <SidebarMenuItem
                  to='/billing/transactionreports/rechargeto'
                  title='Recharge To'
                  hasBullet={true}
                />
              ) : null}

              {currentUser?.user_profile === 1 || currentUser?.user_profile === 2 ? (
                <SidebarMenuItem
                  to='/billing/invoice/create'
                  title='Invoice Create'
                  hasBullet={true}
                />
              ) : null}

              <SidebarMenuItem to='/billing/invoice/list' title='Invoice List' hasBullet={true} />
            </SidebarMenuItemWithSub>
          ) : null}

          <SidebarMenuItemWithSub
            to='/schedules'
            title='Schedules'
            fontIcon='bi bi-calendar-plus'
            icon='bi bi-calendar-plus'
          >
            <SidebarMenuItem to='/schedules/send' title='Send' hasBullet={true} />
            <SidebarMenuItem to='/schedules/pending' title='Pending' hasBullet={true} />
            <SidebarMenuItem to='/schedules/cancel' title='Cancel' hasBullet={true} />
          </SidebarMenuItemWithSub>

          <SidebarMenuItemWithSub
            to='/summeryreport'
            title='Summery Reports'
            fontIcon='bi bi-telephone'
            icon='bi bi-telephone'
          >
            <SidebarMenuItem
              to='/summeryreport/opwisereport'
              title='Op Wise Report'
              hasBullet={true}
            />
            <SidebarMenuItem
              to='/summeryreport/senderwisereport'
              title='Sender Wise Report'
              hasBullet={true}
            />
            <SidebarMenuItem
              to='/summeryreport/opandSenderwisereport'
              title='OP & Sender Wise Report'
              hasBullet={true}
            />
          </SidebarMenuItemWithSub>

          <SidebarMenuItemWithSub
            to='/'
            title='Support'
            fontIcon='bi bi-telephone'
            icon='setting-4'
          >
            <SidebarMenuItemWithSub to='/knowledgebase' title='Knowledge Base' hasBullet={true}>
              <SidebarMenuItem to='/knowledgebase/overview' title='Overview' hasBullet={true} />
              <SidebarMenuItem to='/knowledgebase/article' title='Articles' hasBullet={true} />
              <SidebarMenuItem to='/knowledgebase/category' title='Category' hasBullet={true} />
            </SidebarMenuItemWithSub>

            <SidebarMenuItemWithSub to='/ticket' title='Tickets' hasBullet={true}>
              <SidebarMenuItem to='/tickets/overview' title='Overview' hasBullet={true} />
              <SidebarMenuItem to='/tickets/list' title='Tickets List' hasBullet={true} />
              <SidebarMenuItem to='/tickets/department' title='Department' hasBullet={true} />
            </SidebarMenuItemWithSub>
          </SidebarMenuItemWithSub>

          <SidebarMenuItem to='/settings' title='Settings' icon='wrench' />
        </>
      )}
      {/* <SidebarMenuItemWithSub
        to='/spam-filter'
        title='SpamFilter'
        fontIcon='bi bi-telephone'
        icon='bi bi-telephone'
      >
        <SidebarMenuItem to='/spam-filter/spamfilter' title='Spam Filter' hasBullet={true} />
      </SidebarMenuItemWithSub> */}
      {/* <SidebarMenuItemWithSub to='/error' title='Errors' fontIcon='bi-sticky' icon='cross-circle'>
        <SidebarMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <SidebarMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </SidebarMenuItemWithSub> */}
      {/* <SidebarMenuItemWithSub
        to='/crafted/widgets'
        title='Widgets'
        icon='element-7'
        fontIcon='bi-layers'
      >
        <SidebarMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
      </SidebarMenuItemWithSub> */}
      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div> */}
      {/* <SidebarMenuItemWithSub
        to='/apps/chat'
        title='Chat'
        fontIcon='bi-chat-left'
        icon='message-text-2'
      >
        <SidebarMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
      </SidebarMenuItemWithSub> */}
      {/* <SidebarMenuItem
        to='/apps/user-management/users'
        icon='abstract-28'
        title='User management'
        fontIcon='bi-layers'
      /> */}
      {/* <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTIcon iconName='code' className='fs-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
      {/* <SidebarMenuItem to='' title='Start From Here' hasBullet={true} /> */}
      {/* Role wise menu */}
      {roleDetailMenus.map((menu) => {
        if (menu.submenus) {
          if (menu.view_level === 'Y') {
            return (
              <SidebarMenuItemWithSub to={menu.menu_link} title={menu.menu_name} icon={menu.icon}>
                {menu.submenus?.map((submenu) => {
                  if (submenu.view_level === 'Y') {
                    return (
                      <SidebarMenuItem
                        to={submenu.submenu_link}
                        title={submenu.submenu_name}
                        hasBullet={true}
                      />
                    )
                  }
                })}
              </SidebarMenuItemWithSub>
            )
          }
        }

        if (menu.view_level === 'Y') {
          return <SidebarMenuItem to={menu.menu_link} title={menu.menu_name} icon={menu.icon} />
        }
      })}
    </>
  )
}

export {SidebarMenuMain}
